var en_us = {
    values: {
        'Trips': 'Trips',
        'No trips found': 'No trips found',
        'for the selected timespan': 'for the selected timespan',
        'Select a new timespan or apply new filters': 'Select a new timespan or apply new filters',
    }
}

module.exports = en_us
